export default __webpack_public_path__ + "static/media/blueYoutube.4ab21bfc.svg";